import type { TerminalOperationalHistoryResponse } from "../../../shared/production/terminal-operational";

export type OperatorHistoryItem = TerminalOperationalHistoryResponse["items"][number];
export type OperatorHistoryMode = TerminalOperationalHistoryResponse["mode"];

export function operatorHistoryItemKey(item: OperatorHistoryItem): string {
  return `${item.kind}:${item.kind === "entry" ? item.entry.id : item.kind === "downtime" ? item.downtime.id : item.complaint.id}`;
}

export function appendOperatorHistory(current: OperatorHistoryItem[], next: OperatorHistoryItem[]) {
  const items = new Map(current.map(item => [operatorHistoryItemKey(item), item]));
  for (const item of next) items.set(operatorHistoryItemKey(item), item);
  return [...items.values()];
}
